import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
export default function Header() {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuActive, setIsMenuActive] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    i18n.on("languageChanged", (lng) => {
        document.documentElement.lang = lng;
        document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    });

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
        setIsOpen(false);
    };

    const closeMenu = () => {
        setIsMenuActive(false);
    };

    window.addEventListener('scroll', () => {
        const header = document.getElementById('header');
        if (window.scrollY > 50) {
            header.classList.add('bg-[#ffffff1a]', 'backdrop-blur-[7px]');
        } else {
            header.classList.remove('bg-[#ffffff1a]', 'backdrop-blur-[7px]');
        }
    });

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header id="header" className="btmAni2000Header pad-0 fixed py-[10px] w-full flex flex-col z-[1000] transition-all duration-300 border-b-[1px] border-b-[#ffffff24]">
            <div className="container py-[10px] flex items-center justify-between">
                <Link to="/">
                    <img
                        className="w-[115px] transition-all duration-300"
                        src={
                            scrolled
                                ? require("../../assets/logo/logo.svg").default
                                : require("../../assets/logo/logo.svg").default
                        }
                        alt="Logo"
                    />
                </Link>

                {/* Navigation */}
                <nav className="hidden md:block">
                    <ul className="flex items-center gap-[10px]">
                        {[
                            { path: "/", label: "Home" },
                            { path: "/services", label: "Services" },
                            { path: "/portfolio", label: "Portfolio" },
                            { path: "/events", label: "Events" },
                            { path: "/contact", label: "Contact us" },
                        ].map((item) => (
                            <li key={item.path}>
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) =>
                                        `px-4 py-2 font-bold capitalize transition duration-500 ${isActive ? "text-[#016E82]" : "text-white"
                                        } hover:text-[#016E82]`
                                    }
                                >
                                    {t(item.label)}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="flex items-center gap-[10px]">
                    <div className="relative">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md capitalize"
                        >
                            <img className="w-[33px] h-[33px]" src={require("../../assets/icons/language.svg").default} alt="Language" />
                        </button>
                        {isOpen && (
                            <div className="right-150-mi absolute right-100 right-0 mt-2 w-40 bg-white shadow-lg rounded-md">
                                <div className="py-1">
                                    <button
                                        onClick={() => changeLanguage("en")}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                                    >
                                        English
                                    </button>
                                    <button
                                        onClick={() => changeLanguage("ar")}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                                    >
                                        العربية
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <Link className="d-none bg-[#016E82] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{t("Call us now")}</Link>
                    <button className={`menu ${isMenuActive ? "active" : ""}`} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
            {isMenuActive && (
                <nav className="top-[122px] flex flex-col gap-[20px]">
                    <ul className="flex flex-col gap-4">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#016E82] font-bold capitalize" : "text-black"} hover:text-[#016E82] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Home")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/services"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#016E82] font-bold capitalize" : "text-black"} hover:text-[#016E82] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Services")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/portfolio"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#016E82] font-bold capitalize" : "text-black"} hover:text-[#016E82] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Portfolio")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/events"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#016E82] font-bold capitalize" : "text-black"} hover:text-[#016E82] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Events")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `px-4 py-2 ${isActive ? "text-[#016E82] font-bold capitalize" : "text-black"} hover:text-[#016E82] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("contact us")}
                            </NavLink>
                        </li>
                    </ul>
                    <Link className="w-fit bg-[#016E82] text-center text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{("Call us now")}</Link>
                </nav>
            )}
        </header>
    );
}